import http from './api'

const route = 'app/industrial/'

export default {
  showProducaoSimples: (dataInicial, dataFinal, empresa, tokenContrato) => {
    return http.post(route + 'showProducaoSimples', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresa: empresa,
      tokenContrato: tokenContrato,
    })
  },
}
